import { render, staticRenderFns } from "./ProjectLastFeatures.vue?vue&type=template&id=6ca22a7f"
import script from "./ProjectLastFeatures.vue?vue&type=script&lang=js"
export * from "./ProjectLastFeatures.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports